export default __webpack_public_path__ + "static/media/11.63b3a535.jpg";